import { render, staticRenderFns } from "./JoinResult.vue?vue&type=template&id=1bb63ada&scoped=true&"
import script from "./JoinResult.vue?vue&type=script&lang=js&"
export * from "./JoinResult.vue?vue&type=script&lang=js&"
import style0 from "./JoinResult.vue?vue&type=style&index=0&id=1bb63ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb63ada",
  null
  
)

export default component.exports